import $ from 'jquery';
import BaseAPI from './base-api';

export default class WebUserAPI extends BaseAPI {
  static putWebUserStatusRefresh(status: string) {
    return BaseAPI.perform($.ajax({
      method: 'POST',
      url: `${window.feHost}/api/WebUsers/Status`,
      data: JSON.stringify(status),
      headers: BaseAPI.getRequestHeaders(),
      async: false,
    }));
  }
}
